import React from "react";

const Footer = () => {
  return (
    <footer className="text-white font-MuseoModerno fixed inset-x-0 bottom-0 text-center p-2 ">
      <p>Copyright &copy; 2023 Radser2001 ❤️</p>
    </footer>
  );
};

export default Footer;
